import { Component, OnInit, ChangeDetectorRef, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, FormControl } from '@angular/forms';
import { AppService } from 'src/app/services/app.service';
import { StateService } from 'src/app/services/states.service';
import { MatDialog, MatStepper } from '@angular/material';
import { ShowFileDialog } from '../dialogs-show-file/show-file-dialog.component';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { InstructionDialog } from '../dialogs-instruction/instruction-dialog.component';
import { DialogCommonError } from '../dialogs-errors/dialog-common-error.component';
import { Observable, Subject } from 'rxjs';
import { MailService } from 'src/app/services/mail.service';
import { DialogQuestionMessage } from '../dialogs-question/dialog-question-message.component';
import { formatDate } from '@angular/common';
import { DossierTabIdentityComponent } from 'src/app/partials/dossier-tab-identity/dossier-tab-identity.component';

@Component({
  selector: 'app-dossier-delegation',
  templateUrl: './dossier-delegation.component.html',
  styleUrls: ['./dossier-delegation.component.scss']
})
export class DossierDelegationComponent implements OnInit {

  // ── Formulaire ──────────────────────────────────────────────────────────────
  firstFormGroup: FormGroup;

  // ── État général ─────────────────────────────────────────────────────────────
  helperOn: boolean = true;
  uploadingFile: boolean = false;

  // ── Fichiers ─────────────────────────────────────────────────────────────────
  dataFromUploadedFile: object;

  // ── SIRET / Entreprise ───────────────────────────────────────────────────────
  errorPappers = false;
  entrepriseInfo: any;
  effectifValues: any;
  effectifTranches: any;

  // ── Données dossier ──────────────────────────────────────────────────────────
  dossier: any = '';
  enteteDoss: any = [];
  map_contrat_statut: any = [];
  map_contrat_motif: any = [];
  contrats: any = [];
  statuts: any = [];
  motifs: any = [];
  allstatuts: any;
  allmotifs: any;

  // ── Validation ───────────────────────────────────────────────────────────────
  required: any = [];
  dateContSalaFalse: boolean = false;
  nextButtonIsDisabled = false;
  suivantUploadDisabled: boolean = false;

  // ── Affichage ────────────────────────────────────────────────────────────────
  libellAndToolTip: any = [];
  nbEvent: any;
  errorHandlingMessage = '';
  dateAncienneteBS = '';
  sizemaxFile: number = 4194304;
  numberToUpload: number = 0;
  numberUploaded: number = 0;
  waiting: number = 0;
  isLoading = false;
  hasAtLeastOnePayslip = false;
  isNextButton = false;
  contractsScreen: boolean = false;
  canStartDelegation: boolean = false;
  datedebperiode: any = '';
  datefinperiode: any = '';
  dateParamsForPayslips: any = null;

  // ── Délégation ───────────────────────────────────────────────────────────────
  delegationToken;
  delegationTokenIsValid: boolean = false;
  delegationTokenExpirationDate: Date = null;
  delegatedDossier: object;
  company;
  clientName;
  clientTitle;
  clientMail;
  delegationData = [];
  documentsDelegation = [];
  reloadDocuments: Subject<any> = new Subject<any>();
  reloadBoolRupture: Subject<any> = new Subject<any>();
  reloadEvent: Subject<any> = new Subject<any>();

  titles = {
    maitre: 'Maître',
    madame: 'Madame',
    monsieur: 'Monsieur',
  };

  // ── Misc ─────────────────────────────────────────────────────────────────────
  subscribe: any = [];

  @ViewChild('stepper', { static: true }) myStepper: MatStepper;
  @ViewChild('svgTogglePostSala', { static: false }) svgTogglePostSala: any;
  @ViewChild(DossierTabIdentityComponent, {static: false}) tabIdentity: DossierTabIdentityComponent;


  constructor(
    private activatedRoute: ActivatedRoute,
    private formBuilder: FormBuilder,
    private appService: AppService,
    private stateService: StateService,
    private mailService: MailService,
    private httpClient: HttpClient,
    public dialog: MatDialog,
    private cdf: ChangeDetectorRef,
    private router: Router
  ) {
    this.delegationToken = this.activatedRoute.snapshot.params.token;
  }

  // ════════════════════════════════════════════════════════════════════════════
  // Lifecycle
  // ════════════════════════════════════════════════════════════════════════════

  ngOnInit() {
    this.waiting = environment.waiting;

    this.subscribe['sizefilemax'] = this.appService.getSizeFileMax().subscribe((res) => {
      if (res && res.result) {
        this.sizemaxFile = res.result;
      }
    });

    // Sans token de délégation valide, on redirige
    if (!this.delegationToken) {
      this.router.navigateByUrl('/dossier');
      return;
    }

    this.appService.getDossierFromDelegationToken(this.delegationToken).subscribe((response) => {
      if (response.result.dossier && response.result.token) {
        const result = response.result;
        this.delegationTokenExpirationDate = new Date(response.result.expirationDate);
        environment.tokenauth = result.token;
        environment.tokenDelegation = this.delegationToken;
        this.delegatedDossier = result.dossier;
        this.dossier = result.dossier;
        this.clientName = result.clientName;
        this.company = result.company;
        this.delegationTokenIsValid = true;
        this.clientMail = result.clientMail;

        let currentTitle = '';
        for (const label in this.titles) {
          if (result.clientTitle === label) {
            currentTitle = this.titles[label];
          }
        }
        this.clientTitle = currentTitle;

        this.appService.getTokenCalcForDelegation().subscribe((response) => {
          if (response.result.token_calc) {
            environment.tokencalc = response.result.token_calc;
          }
        });

        this.forceReloadDocuments(this.dossier.id);
        this.afterOnInit();
      } else if (response.result.isDelegationDone) {
        this.myStepper.selectedIndex = 3;
        this.clientName = response.result.clientName;
        this.company = response.result.company;
        this.helperOn = false;
      } else {
        // Token expiré
        this.delegationTokenExpirationDate = new Date(response.result.expirationDate);
        this.cdf.detectChanges();
      }
    });
  }

  afterOnInit() {
    this.appService.getParameterPossibleValues(['EFFECT_EMP']).subscribe((res) => {
      this.effectifValues = res.result['EFFECT_EMP'];
    });

    this.httpClient
      .get('assets/content-sirene.json?v=' + window['cobham_version'])
      .subscribe((res) => {
        this.effectifTranches = res;
      });

    this.subscribe['tooltips'] = this.appService.getLibelleTooltip().subscribe((res) => {
      if (res && res.result) {
        this.libellAndToolTip = res.result;
      }
      for (const element in this.libellAndToolTip) {
        if (this.libellAndToolTip[element].parameters) {
          this.libellAndToolTip[element].parameters = JSON.parse(
            this.libellAndToolTip[element].parameters
          ).ListValues;
        }
      }
    });

    this.subscribe['json'] = this.httpClient
      .get('assets/mappage.json?v=' + window['cobham_version'])
      .subscribe((res) => {
        this.map_contrat_motif = res['map_contrat_motif'];
        this.map_contrat_statut = res['map_contrat_statut'];

        this.subscribe['json2'] = this.appService
          .getParameterPossibleValues(['NAT_CONT', 'STATUT', 'MOTIF_SORTIE'])
          .subscribe((res) => {
            this.contrats = res['result']['NAT_CONT'];
            this.statuts = res['result']['STATUT'];
            this.allstatuts = res['result']['STATUT'];
            this.allmotifs = res['result']['MOTIF_SORTIE'];
            this.motifs = res['result']['MOTIF_SORTIE'];

            this.loadDossier();
          });
      });
  }

  private loadDossier() {
    if (this.dossier && this.dossier.id) {
      this.appService.getDossierById(this.dossier.id).subscribe((data) => {
        if (data.result.error && data.result.code) {
          this.errorHandlingMessage = data.result.error;
        } else if (data && data.result && data.result.datas && data.result.datas[0]) {
          const dossier = data.result.datas[0];
          this.stateService.updateDossier(dossier);
          this.initDossierForm(dossier);

          if (!this.dossier.bulletinSalaire || this.dossier.bulletinSalaire.length === 0) {
            this.myStepper.selectedIndex = 0;
          }
        }
      });
    }
  }

  private initDossierForm(dossier: any) {
    this.dossier = dossier;

    this.firstFormGroup = this.formBuilder.group({
      civiliteSala: new FormControl(dossier.civilite || ''),
      firstnameSala: new FormControl(dossier.prenom || ''),
      nameSala: new FormControl(dossier.nom || ''),
      nameEntSala: new FormControl(dossier.entreprise || ''),
      siret: new FormControl(dossier.siret || ''),
      postSala: new FormControl(
        dossier.poste === 'FALSE' || !dossier.poste ? 'FALSE' : 'TRUE'
      ),
      dateContSala: new FormControl(
        dossier['datedebut']
          ? dossier['datedebut'].toString().split('T')[0]
          : dossier.datedebutperiode
            ? dossier.datedebutperiode.toString().split('T')[0]
            : ''
      ),
      dateContSortieSala:
        dossier.poste === 'FALSE' || !dossier.poste
          ? new FormControl(
            dossier.datesortie
              ? dossier.datesortie.split('T')[0]
              : dossier.datecreation
                ? dossier.datecreation.split('T')[0]
                : null
          )
          : new FormControl(''),
      typeSala: new FormControl(dossier.typecontrat || ''),
      statutSala: new FormControl(dossier.statutsalarie || ''),
      motifSala: new FormControl(dossier.motifsortie || ''),
      maladieSala: new FormControl('FALSE'),
      dateMaladieSala: new FormControl(''),
      contRompu: new FormControl('FALSE'),
      dateRupt: new FormControl(''),
      nomDateRupt: new FormControl(''),
      boolRupt: new FormControl('FALSE'),
    });

    // Charger les entêtes
    this.subscribe['entetesdoss'] = this.appService
      .getDossierEntete(this.dossier.id)
      .subscribe((res) => {
        if (res.result) {
          this.dossier.entete = res.result.entete;
          res.result.entete.forEach((entete) => {
            if (entete.parametre.code && entete.value)
              this.enteteDoss[entete.parametre.code] = entete.value;
            if (entete.parametre.code && entete.valueint)
              this.enteteDoss[entete.parametre.code] = entete.valueint;
            if (entete.parametre.code && entete.valuedate)
              this.enteteDoss[entete.parametre.code] = entete.valuedate;
          });

          this.forceReloadBoolRupture(this.enteteDoss['BOOL_RUPT']);
          this.initFormWithEntete();
          this.canStartDelegation = true;

          this.appService
            .getDatePeriode(
              this.firstFormGroup.get('dateContSala').value,
              this.firstFormGroup.get('postSala').value,
              this.firstFormGroup.get('dateContSortieSala').value,
              this.firstFormGroup.get('motifSala').value,
              this.firstFormGroup.get('dateRupt').value,
              this.firstFormGroup.get('maladieSala').value,
              this.firstFormGroup.get('dateMaladieSala').value
            )
            .subscribe((res) => {
              if (res.result.datedeb) this.datedebperiode = new Date(res.result.datedeb);
              if (res.result.datefin) this.datefinperiode = new Date(res.result.datefin);
              this.dateParamsForPayslips = {
                startDatePeriod: this.datedebperiode,
                endDatePeriod: this.datefinperiode,
              };
            });

          // Si le dossier n'a pas encore de bulletins, on reste sur l'étape upload
          if (!this.dossier.bulletinSalaire || this.dossier.bulletinSalaire.length === 0) {
            this.helperOn = true;
          } else {
            this.helperOn = false;
            this.myStepper.selectedIndex = 1;
          }
        }
      });
  }

  // ════════════════════════════════════════════════════════════════════════════
  // Formulaire salarié
  // ════════════════════════════════════════════════════════════════════════════

  async checkDossierForm() {
    const valid = await this.tabIdentity.validate();
    if (valid) {
      this.submitCreatDoss();
    } else {
      this.nextButtonIsDisabled = false;
    }
  }

  submitCreatDoss() {
    const dossier = this.firstFormGroup.getRawValue();
    let effectifUpload: number;
    let effectifEntete: any;
    const listEffectifs = [];

    if (this.entrepriseInfo) {
      for (const [key, value] of Object.entries(this.effectifTranches)) {
        if (key === this.entrepriseInfo.tranche_effectif) {
          this.entrepriseInfo.tranche_effectif = value;
        }
      }

      this.effectifValues.forEach((effectif) => {
        const parsedValues = effectif.Value.split('a');
        if (parsedValues.length > 1) {
          listEffectifs.push({ min: parsedValues[0], max: parsedValues[1] });
        } else if (effectif.Value.includes('plus')) {
          listEffectifs.push({ min: effectif.Value.split('plus')[0] });
        }
      });

      effectifUpload = parseInt(this.entrepriseInfo.tranche_effectif);
      listEffectifs.forEach((effectif, index) => {
        if (effectif.max && effectif.min) {
          if (effectifUpload >= effectif.min && effectifUpload <= effectif.max)
            effectifEntete = this.effectifValues[index];
        } else if (effectif.min && effectifUpload >= effectif.min) {
          effectifEntete = this.effectifValues[index];
        }
      });
    }

    this.subscribe['dateperiode'] = this.appService
      .getDatePeriode(
        this.firstFormGroup.get('dateContSala').value,
        this.firstFormGroup.get('postSala').value,
        this.firstFormGroup.get('dateContSortieSala').value,
        this.firstFormGroup.get('motifSala').value,
        this.firstFormGroup.get('dateRupt').value,
        this.firstFormGroup.get('maladieSala').value,
        this.firstFormGroup.get('dateMaladieSala').value
      )
      .subscribe((res) => {
        if (res.result.datedeb) this.datedebperiode = new Date(res.result.datedeb);
        if (res.result.datefin) this.datefinperiode = new Date(res.result.datefin);

        if (this.dossier === '') {
          // Création
          this.subscribe['assdoss'] = this.appService
            .addDossier(
              dossier.civiliteSala,
              dossier.siret || '',
              dossier.firstnameSala,
              dossier.nameSala,
              dossier.nameEntSala,
              dossier.postSala,
              dossier.dateContSala,
              this.datedebperiode,
              dossier.dateContSortieSala,
              dossier.typeSala,
              dossier.statutSala,
              dossier.motifSala,
              dossier.maladieSala,
              dossier.dateMaladieSala,
              this.datefinperiode,
              dossier.contRompu,
              dossier.dateRupt,
              dossier.nomDateRupt,
              dossier.boolRupt,
              null,  // couponId — non applicable en délégation
              dossier.nameSala,
              dossier.nameEntSala,
              'FALSE'
            )
            .subscribe((res) => {
              this.dossier = res.result.dossier;
              this.dossier.datedebut = dossier.dateContSala;
              this.dossier.datesortie = dossier.dateContSortieSala;
              this.dossier.poste = dossier.postSala;
              this.dossier.motifsortie = dossier.motifSala;
              this.stateService.updateDossier(this.dossier);

              if (this.entrepriseInfo && effectifEntete) {
                this.appService
                  .addDossierEntete(this.dossier.id, { EFFECT_EMP: effectifEntete.Value })
                  .subscribe();
              }

              if (this.dataFromUploadedFile && Object.keys(this.dataFromUploadedFile).length > 0) {
                this.appService.processRecoResponse(this.dossier.id, this.dataFromUploadedFile).subscribe(() => {
                  this.forceReloadPayslips();
                  this.dataFromUploadedFile = {};
                  this.myStepper.next();
                  this.nextButtonIsDisabled = false;
                });
              } else {
                this.myStepper.next();
                this.nextButtonIsDisabled = false;
              }
            });
        } else {
          // Mise à jour
          this.subscribe['updatedoss'] = this.appService
            .updateDossierDelegation(
              this.dossier.id,
              dossier.civiliteSala,
              dossier.firstnameSala,
              dossier.nameSala,
              dossier.nameEntSala,
              dossier.postSala,
              dossier.dateContSala,
              this.datedebperiode,
              dossier.dateContSortieSala,
              dossier.typeSala,
              dossier.statutSala,
              dossier.motifSala,
              dossier.maladieSala,
              dossier.dateMaladieSala,
              this.datefinperiode,
              dossier.contRompu,
              dossier.dateRupt,
              dossier.nomDateRupt,
              dossier.boolRupt,
              dossier.siret || '',
              dossier.nameSala,
              dossier.nameEntSala,
              'FALSE'
            )
            .subscribe((res) => {
              this.dossier = res.result.dossier;
              this.dossier.datedebut = dossier.dateContSala;
              this.dossier.datesortie = dossier.dateContSortieSala;
              this.dossier.poste = dossier.postSala;
              this.dossier.motifsortie = dossier.motifSala;

              if (this.entrepriseInfo && effectifEntete) {
                this.appService
                  .addDossierEntete(this.dossier.id, { EFFECT_EMP: effectifEntete.Value })
                  .subscribe();
              }

              if (this.dataFromUploadedFile && Object.keys(this.dataFromUploadedFile).length > 0) {
                this.appService.processRecoResponse(this.dossier.id, this.dataFromUploadedFile).subscribe(() => {
                  this.forceReloadPayslips();
                  this.dataFromUploadedFile = {};
                  this.myStepper.next();
                  this.nextButtonIsDisabled = false;
                });
              } else {
                this.myStepper.next();
                this.nextButtonIsDisabled = false;
              }
            });
        }
      });
  }

  // ════════════════════════════════════════════════════════════════════════════
  // Validation & soumission
  // ════════════════════════════════════════════════════════════════════════════

  changeEtatValidationDossier(stepper: MatStepper, iddossier, etat) {
    this.appService.changeEtatValidationDossier(iddossier, etat).subscribe();
    if (etat < 4) stepper.next();
    if (etat === 5) this.consolidationBS(stepper, false, true);
  }

  consolidationBS(stepper: MatStepper, displayErreurOrGoNext = true, disableSuivantBtn = false) {
    if (disableSuivantBtn) this.suivantUploadDisabled = true;

    if (this.subscribe && this.subscribe['consolidation']) {
      this.subscribe['consolidation'].unsubscribe();
    }

    this.subscribe['consolidation'] = this.appService
      .consolidationBS(this.dossier.id)
      .subscribe((data) => {
        if (data.result.bulletinSalaire) {
          this.dossier.bulletinSalaire = data.result.bulletinSalaire;
          this.stateService.updateDossier(this.dossier);
          this.appService.validationCobhamMail(this.clientMail, this.dossier.id).subscribe((res) => {
            if (res.success) {
              stepper.selectedIndex = 3;
            }
            else {
              this.errorHandlingMessage = "Erreur durant l'envoi de mail."
            }
            this.cdf.detectChanges();
          })
        }
      });
  }

  // ════════════════════════════════════════════════════════════════════════════
  // Helpers formulaire
  // ════════════════════════════════════════════════════════════════════════════

  computeBoolRupt(postSalaValue = null) {
    const postSala = postSalaValue || this.firstFormGroup.getRawValue().postSala;
    if (postSala === 'FALSE' && this.firstFormGroup.get('contRompu').value === 'FALSE') {
      this.firstFormGroup.get('contRompu').setValue('TRUE');
    }
    if (postSala === 'FALSE' || this.firstFormGroup.get('contRompu').value === 'TRUE') {
      this.firstFormGroup.get('boolRupt').setValue('TRUE');
    } else {
      this.firstFormGroup.get('boolRupt').setValue('FALSE');
    }
  }

  initFormWithEntete() {
    if ('entete' in this.dossier) {
      this.dossier['entete'].forEach((entete) => {
        if (entete.parametre.code.match(/BOOL_MALADIE_LIC/))
          this.firstFormGroup.get('maladieSala').setValue(entete.value === '1' || entete.value === 'TRUE' ? 'TRUE' : 'FALSE');
        if (entete.parametre.code.match(/DT_ARRET_TRAV/) && entete.valuedate)
          this.firstFormGroup.get('dateMaladieSala').setValue(entete.valuedate.split('T')[0]);
        if (entete.parametre.code.match(/BOOL_CONT_ROMPU/))
          this.firstFormGroup.get('contRompu').setValue(entete.value === '1' || entete.value === 'TRUE' ? 'TRUE' : 'FALSE');
        if (entete.parametre.code.match(/DATE_RUPT/) && entete.valuedate)
          this.firstFormGroup.get('dateRupt').setValue(entete.valuedate.split('T')[0]);
        if (entete.parametre.code.match(/BOOL_RUPT/))
          this.firstFormGroup.get('boolRupt').setValue(entete.value === '1' || entete.value === 'TRUE' ? 'TRUE' : 'FALSE');
      });
    }
  }

  setDelegationValues() {
    this.delegationData['DT_DEBUT_CONT'] = this.firstFormGroup.get('dateContSala').value;
  }

  goToContracts() {
    this.setDelegationValues();
    this.contractsScreen = true;
  }

  // ════════════════════════════════════════════════════════════════════════════
  // Délégation : quitter
  // ════════════════════════════════════════════════════════════════════════════

  stopDelegation() {
    this.openQuitDialog(false);
  }

  quitDelegation() {
    this.openQuitDialog(true);
  }

  private openQuitDialog(hasProgress: boolean) {
    const userLocale = this.getUsersLocale('fr');
    const daysDiff = this.dateDiffInDays(new Date(), this.delegationTokenExpirationDate);
    const expireString = daysDiff === 1 ? 'demain' : `dans ${daysDiff} jours`;
    const expireDate = formatDate(this.delegationTokenExpirationDate, 'longDate', userLocale);
    const body = [];

    if (hasProgress) {
      body.push(
        'Vous allez quitter Rupture by Cobham. Les données que vous avez saisies et les documents que vous avez commencé à charger sont mémorisés.'
      );
      body.push(
        "Si vous avez besoin de compléter le dossier et d'ajouter de nouveaux documents, merci de cliquer de nouveau sur le lien que vous avez reçu par mail."
      );
    } else {
      body.push(
        "Vous allez quitter Rupture by Cobham. Si vous avez besoin de compléter le dossier et d'ajouter de nouveaux documents, merci de cliquer de nouveau sur le lien que vous avez reçu par mail."
      );
    }

    body.push(
      `Merci de noter que le lien expirera ${expireString}, soit le ${expireDate}. Au-delà de ce délai, il faudra demander à ${this.clientName} de ${this.company} de vous renvoyer un nouveau lien.`
    );

    const dialogRef = this.dialog.open(DialogQuestionMessage, {
      width: '50%',
      data: { title: 'Quitter Rupture by Cobham ?', body },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result.positive) this.router.navigateByUrl('/');
    });
  }

  delegationSkipCreation() {
    this.helperOn = false;
  }

  forceSubmitDelegation() {
    this.changeEtatValidationDossier(this.myStepper, this.dossier.id, 4);
  }

  // ════════════════════════════════════════════════════════════════════════════
  // Affichage fichiers
  // ════════════════════════════════════════════════════════════════════════════

  showFile(file: any) {
    let fileurl = '';
    let pdfOk = true;
    const pdfExt = /\.pdf$/;
    let page: number;

    if (file[1]) {
      fileurl = file[1]['urlfront'] || file[0]['url'];
      pdfOk = pdfExt.test(file[0]['nom']);
      page = file[1]['page'] || 1;
    } else {
      fileurl = file['urlfront'] || file['url'];
      pdfOk = pdfExt.test(file['nom']);
      page = file['page'] || 1;
    }

    this.dialog.open(ShowFileDialog, {
      width: '100%',
      panelClass: 'viewpdf-dialog',
      data: {
        url: fileurl,
        pdf: pdfOk,
        name: file[0] ? file[0]['nom'] : file['nom'],
        page,
      },
    });
  }

  seeInstruction(instruction) {
    this.dialog.open(InstructionDialog, {
      width: '100%',
      panelClass: instruction.numInstruction === 5 ? 'instruction5-dialog' : 'instruction-dialog',
      data: {
        numInstruction: instruction.numInstruction,
        datesortie: this.dossier.datesortie,
        datecreation: this.dossier.datecreation,
        datedebperiode: this.datedebperiode,
      },
    });
  }

  getTypeError(error) {
    switch (error[0].erreur) {
      case 'Oups, ce document est illisible ou ne correspond pas à un bulletin de salaire.':
        return 1;
      case 'Oups, ce bulletin de salaire semble appartenir à une autre personne ou un autre contrat de travail.':
        return 2;
      case 'Oups, ce bulletin de salaire ne correspond pas à la période demandée.':
      case 'Ce bulletin n\'a pas de période reconnue':
        return 3;
      case 'Oups, ce document a déjà été chargé et se retrouve en double':
        return 5;
      case 'Oups, la page principale de ce bulletin de salaire semble manquer.':
        return 6;
      default:
        return null;
    }
  }

  // ════════════════════════════════════════════════════════════════════════════
  // Events depuis composants enfants
  // ════════════════════════════════════════════════════════════════════════════

  setHasAtLeastOnePayslip(value: boolean) {
    this.hasAtLeastOnePayslip = value;
  }
  setErrorHandlingMessage(error) {
    this.errorHandlingMessage = error;
  }
  setIsLoading(isLoading: boolean) {
    this.isLoading = isLoading;
  }
  setIsNextButton(isNextButton: boolean) {
    this.isNextButton = isNextButton;
  }
  forceReloadDocuments(dossierId) {
    this.reloadDocuments.next(dossierId);
  }
  forceReloadBoolRupture(boolRupture) {
    this.reloadBoolRupture.next(boolRupture);
  }
  forceReloadPayslips() {
    this.reloadEvent.next();
  }
  forceQuitDelegation() {
    this.quitDelegation();
  }

  // Dans dossier-delegation.component.ts
  onFileUploaded(event: any) {
    this.required = [];
    const res = event;
    const arrayCode = [
      'CIV_SAL',
      'NOM_COMPL_SAL',
      'NOM_EMP',
      'SIRET',
      'DT_ENT_BS',
      'DT_S_BS',
      'DT_ANC_BS',
    ];
    const values = this.getDataFromRecoResponse(arrayCode, res);
    this.dataFromUploadedFile = {
      directory: res.directory,
      filename: res.filename,
      url: '/' + res.url,
      validation: res.validation,
      result: res,
    };

    if (values['CIV_SAL']) {
      const civilite = values['CIV_SAL'];
      if (civilite === 'Mr' || civilite === 'Monsieur') values['CIV_SAL'] = 'M';
      else if (civilite === 'Mrs' || civilite === 'Madame') values['CIV_SAL'] = 'F';
      else values['CIV_SAL'] = '';
    }

    if (values['NOM_COMPL_SAL']) {
      let identityValues = values['NOM_COMPL_SAL'].split(' ').filter((n: string) => n);
      const identity = { nom: identityValues[0], prenom: '' };
      for (let idx = 1; idx < identityValues.length; idx++) {
        identity.prenom += identityValues[idx];
        if (identityValues.length - 1 !== idx) identity.prenom += ' ';
      }
      values['NOM_COMPL_SAL'] = identity;
    }

    this.firstFormGroup.get('civiliteSala').setValue(values['CIV_SAL'] || '');
    this.firstFormGroup.get('firstnameSala').setValue(values['NOM_COMPL_SAL'].prenom || '');
    this.firstFormGroup.get('nameSala').setValue(values['NOM_COMPL_SAL'].nom || '');
    this.firstFormGroup.get('nameEntSala').setValue(values['NOM_EMP'] || '');
    this.firstFormGroup.get('siret').setValue(values['SIRET'] || '');
    this.firstFormGroup.get('dateContSala').setValue('');
    this.firstFormGroup.get('dateContSortieSala').setValue('');

    try {
      if (values['DT_ENT_BS']) {
        this.firstFormGroup.get('dateContSala').setValue(this.fromDateToString(values['DT_ENT_BS']).split('T')[0]);
      }
      if (!values['DT_ENT_BS'] && values['DT_ANC_BS']) {
        this.dateAncienneteBS = new Date(this.fromDateToString(values['DT_ANC_BS'].split('T')[0])).toLocaleDateString('fr-FR');
      }
      if (values['DT_S_BS']) {
        this.firstFormGroup.get('dateContSortieSala').setValue(this.fromDateToString(values['DT_S_BS']).split('T')[0]);
        this.computeBoolRupt('FALSE');
        if (this.firstFormGroup.get('postSala').value === 'TRUE') {
          this.firstFormGroup.get('postSala').setValue('FALSE');
          if (this.svgTogglePostSala) {
            this.svgTogglePostSala['positionStart'] = 'FALSE';
            this.svgTogglePostSala['positionCxButton'] = '14';
            this.svgTogglePostSala['fillColorButton'] = '#6016AA';
            this.svgTogglePostSala['fillColorBack'] = '#FFF';
          }
        }
      }
    } catch (e) {
      console.log(e);
    }
  }

  onUploadingFile(event: any) {
    this.uploadingFile = event;
  }

  getDataFromRecoResponse(arrayCode, response) {
    const result = {};
    const dataDoss = [];
    const values = response.validation.result.datas[0].VALUES;
    values.forEach((entete) => {
      if (entete.VALUE && entete.CODE) dataDoss[entete.CODE] = entete.VALUE;
    });
    for (let i = 0; i < arrayCode.length; i++) {
      if (dataDoss[arrayCode[i]] && !result[arrayCode[i]]) {
        result[arrayCode[i]] = dataDoss[arrayCode[i]];
      }
    }
    return result;
  }

  fromDateToString(date) {
    if(typeof date != 'object'){
      date = date.replaceAll('.', '-');
      const d = new Date(date.toString());
      d.setTime(d.getTime() - d.getTimezoneOffset() * 60000);
      return d.toISOString().substr(0, 19);
    }
  }

  dateDiffInDays(dateA: Date, dateB: Date): number {
    const MS_PER_DAY = 1000 * 60 * 60 * 24;
    const utc1 = Date.UTC(dateA.getFullYear(), dateA.getMonth(), dateA.getDate());
    const utc2 = Date.UTC(dateB.getFullYear(), dateB.getMonth(), dateB.getDate());
    return Math.floor((utc2 - utc1) / MS_PER_DAY);
  }

  getUsersLocale(defaultValue) {
    if (typeof window === 'undefined' || typeof window.navigator === 'undefined') return defaultValue;
    const wn = window.navigator as any;
    let lang = wn.languages ? wn.languages[0] : defaultValue;
    lang = lang || wn.language || wn.browserLanguage || wn.userLanguage;
    return lang;
  }

  ngOnDestroy() {
    this.cdf.detach();
    for (const element in this.subscribe) {
      this.subscribe[element].unsubscribe();
      this.subscribe[element] = null;
    }
  }

  onSetData(event: { var: string; value: any }) {
    if (event.var === 'entrepriseInfo') {
      this.entrepriseInfo = event.value;
    }
  }
}
